// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3gFH2","selects":"Documents_selects__1qgda"};